import React, { useState, useEffect } from 'react';
import 'slick-carousel/slick/slick-theme.css';
import 'slick-carousel/slick/slick.css';
import {BrowserRouter,Routes,Route} from 'react-router-dom';
import Home from "./elements/Home";
import Login from "./elements/Login";
import Items from "./elements/items";
import Orders from "./elements/Orders";
import Invoices from "./elements/invoices";
import Users from "./elements/users";
import Banners from "./elements/banners";
import Support from "./elements/support";
import Accounting from "./elements/accounting";

function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<Login />} />
        <Route path="/Home" element={<Home />} />
        <Route path="/myitems" element={<Items />} />
        <Route path="/myorders" element={<Orders />} />
        <Route path="/myinvoices" element={<Invoices />} />
        <Route path="/myusers" element={<Users />} />
        <Route path="/mybanners" element={<Banners />} />
        <Route path="/support" element={<Support />} />
        <Route path="/myaccounting" element={<Accounting />} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;
